module.exports = __webpack_public_path__ + "media/yongbao.1d78c366.mp3";